import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import SearchTextBox from 'srcReact/components/common2/SearchTextBox'
import useInfinitScroll from 'srcReact/helpers/hooks/useInfinitScroll'
import styles from './styles.module.scss'
import { urlSearchParams } from 'srcReact/helpers/utils'
import { useTranslation } from 'react-i18next'
import MemberImages from 'srcReact/components/common2/MemberImages'
import Spinner from 'srcReact/components/common2/Spinner'
import Button from 'srcReact/components/common2/Button'
import Icon from 'srcReact/components/icons/Icon'
import NoResultInSearch from '../../../MessengerPage/components/NoResultInSearch'
import { Alert } from 'srcReact/components/common2/Alert'
import { shareMediaActions } from './actions'
import MemberNames from '../MemberNames'

export default function ShareMedia({ mediaFile, closeModal, openedConversation = null }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [search, setSearch] = useState('')
  const [selectedConversations, setSelectedConversations] = useState([])
  const [shareTriggred, setShareTriggred] = useState(false)
  const [pagination, setPagination] = useState({
    nextOffset: 0,
    isPagination: false
  })
  const {
    common: { isMobile, isNative, isTablet },
    organization: { current_organization },
    shareMedia: { loading, error, conversations, conversationsStat, success }
  } = useSelector((state) => state)

  const handleSearch = (searchValue) => {
    if (searchValue.length >= 2 || searchValue.length === 0) {
      setPagination({
        nextOffset: 0,
        isPagination: false
      })
      setSearch(searchValue)
    }
  }
  const lastConversationRef = useInfinitScroll(
    loading,
    conversationsStat && conversationsStat.remaining,
    conversationsStat && conversationsStat.nextOffset,
    setPagination,
    [loading]
  )

  useEffect(() => {
    // nativeapp
    if (isNative) {
      if (search.length >= 2) {
        setShareTriggred(false)
        dispatch(
          shareMediaActions.searchConversationsToShare(
            urlSearchParams('organization_id'),
            search,
            pagination,
            'users,conversations'
          )
        )
      } else {
        dispatch(shareMediaActions.getConversationsToShare(urlSearchParams('organization_id'), search, pagination))
      }
      return
    }
    if (current_organization && current_organization.info && current_organization.info.id > 0) {
      if (search.length >= 2) {
        setShareTriggred(false)
        dispatch(
          shareMediaActions.searchConversationsToShare(
            current_organization.info.id,
            search,
            pagination,
            'users,conversations'
          )
        )
      } else {
        dispatch(shareMediaActions.getConversationsToShare(current_organization.info.id, search, pagination))
      }
    }
  }, [pagination, search, current_organization])

  const handleRemoveAlert = () => {
    setShareTriggred(false)
  }

  useEffect(() => {
    if (!loading && shareTriggred && success) {
      setSelectedConversations([])
      //  setTimeout(() => handleRemoveAlert(), 3000)
    }
  }, [loading, shareTriggred, success])

  const sendMedia = () => {
    setShareTriggred(true)
    dispatch(shareMediaActions.sendMedia(selectedConversations, mediaFile.id.toString()))
  }

  const selectConversation = (conversation) => {
    setSelectedConversations([...selectedConversations, conversation])
  }

  const unSelectConversation = (conversation) => {
    const filteredConvs = selectedConversations.filter((c) => c.conversation.id !== conversation.conversation.id)
    setSelectedConversations(filteredConvs)
  }
  return (
    <React.Fragment>
      {!loading && shareTriggred && success && (
        <Alert
          text={t('messenger.shareMedia.mediaShareSuccess')}
          type='success'
          onClose={handleRemoveAlert}
          className={styles.alert}
        />
      )}
      <div className={styles.shareContainer}>
        <div className={styles.searchOrAdd}>
          <SearchTextBox
            minimumSearchChar={2}
            size='large'
            iconPosition='start'
            placeholder={t('messenger.searchConvsPlaceholder2')}
            handleSearch={handleSearch}
            cssClass={styles.searchContainer}
          />
        </div>

        <div className={styles.list}>
          {!loading && !error && search.length >= 2 && conversations.length === 0 && (
            <NoResultInSearch customCss={styles.noresult} />
          )}
          {conversations &&
            conversations.length > 0 &&
            conversations.map((conversation, index) => {
              const isLastConversation = conversations.length === index + 1
              const conversationToExclude = openedConversation
                ? conversation.conversation.id === openedConversation.conversation.id
                : false
              const isConvSelected = isConvAlreadySelected(selectedConversations, conversation)

              return (
                !conversationToExclude && (
                  <React.Fragment>
                    <div
                      role='button'
                      {...(isConvSelected
                        ? {
                            onClick: () => unSelectConversation(conversation)
                          }
                        : {
                            onClick: () => selectConversation(conversation)
                          })}
                      ref={isLastConversation ? lastConversationRef : null}
                      key={`${conversation.conversation.id}_${index}`}
                      className={`${styles.memberInList}`}>
                      {isConvSelected && <div className={styles.indicatorAdded} />}
                      <MemberImages
                        imgSizeSingle='small'
                        imgSizeDouble='tiny'
                        imgSizeMore='tiny'
                        imgSingleCss={`${styles.oneImageCSS}`}
                        imgDoubleCss={styles.twoImageCSS}
                        imgMoreCss={styles.moreImageCSS}
                        displayCount={3}
                        conversationName={conversation.conversation.user_conversation_name}
                        members={conversation.active_users.filter((u) => !u.is_logged_user)}
                      />

                      <div className={`${styles.conversationInfo} `}>
                        {isMobile ? (
                          <div className={styles.convNameTimeContainer}>
                            <div className={styles.conversationName}>
                              <MemberNames
                                id={conversation.conversation.id}
                                members={conversation.active_users.filter((u) => !u.is_logged_user)}
                                conversationName={conversation.conversation.user_conversation_name}
                                isMobile={isMobile || isNative}
                                isTablet={isTablet}
                              />
                            </div>
                          </div>
                        ) : (
                          <div className={styles.conversationName}>
                            <MemberNames
                              id={conversation.conversation.id}
                              members={conversation.active_users.filter((u) => !u.is_logged_user)}
                              conversationName={conversation.conversation.user_conversation_name}
                              isMobile={isMobile || isNative}
                              isTablet={isTablet}
                            />
                          </div>
                        )}
                      </div>
                      {isConvSelected ? (
                        <span className={styles.selectIconButton}>
                          <Icon name='minus' size='large' />
                        </span>
                      ) : (
                        <span className={styles.selectIconButton}>
                          <Icon name='add' size='large' />
                        </span>
                      )}
                    </div>
                  </React.Fragment>
                )
              )
            })}

          {loading || (error && error === 'cancelTokenError') ? <Spinner customCss={styles.spinner} /> : null}
        </div>
        <div className={styles.buttons}>
          <Button style='secondary' handleClick={closeModal} text={t('messenger.btnCancel1')} />
          <Button disabled={loading && shareTriggred} handleClick={sendMedia} text={t('messenger.share')} />
          {loading && shareTriggred ? <Spinner /> : null}
        </div>
      </div>
    </React.Fragment>
  )
}

function isConvAlreadySelected(conversations, conversation) {
  return conversations.some((conv) => conv.conversation.id === conversation.conversation.id)
}
